/* AutoPrintBanner — Ecommerce tab üstünde kompakt durum göstergesi.
 * Kapalıysa bir 'Aç' kestirmesi, açıksa son basım + sayaç + ayarlara link.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Zap, ZapOff, Settings as SettingsIcon, Printer } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const HDR = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export default function AutoPrintBanner({ onGoSettings }) {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const fetchStats = () => {
            axios.get(`${API}/api/bol/auto-print/stats`, { headers: HDR() })
                .then((r) => setStats(r.data)).catch(() => {});
        };
        fetchStats();
        const t = setInterval(fetchStats, 30000); // her 30 sn yenile
        return () => clearInterval(t);
    }, []);

    if (!stats) return null;
    const isOn = stats.enabled;
    const lastTime = stats.last_print_at
        ? new Date(stats.last_print_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
        : null;

    return (
        <div className={`rounded-lg p-2.5 flex items-center gap-2 text-xs ${
            isOn
                ? 'bg-emerald-50 border border-emerald-200 text-emerald-900'
                : 'bg-gray-50 border border-gray-200 text-gray-700'
        }`} data-testid="auto-print-banner">
            {isOn ? <Zap size={14} className="text-emerald-600 shrink-0" /> : <ZapOff size={14} className="text-gray-400 shrink-0" />}
            <div className="flex-1">
                <span className="font-bold">Otomatik Basım</span>
                <span className="ml-1.5">
                    {isOn
                        ? `AÇIK · bugün ${stats.today_printed || 0} sipariş`
                        : 'KAPALI'}
                </span>
                {isOn && lastTime && (
                    <span className="ml-2 text-emerald-700/70">
                        <Printer size={10} className="inline mr-0.5" /> son: {lastTime}
                    </span>
                )}
                {stats.stats_today?.errors > 0 && (
                    <span className="ml-2 text-rose-700 font-semibold">⚠ {stats.stats_today.errors} hata</span>
                )}
            </div>
            <button onClick={onGoSettings}
                className="h-7 px-2 text-[11px] font-bold rounded inline-flex items-center gap-1 bg-white border border-current/30 hover:bg-current/5"
                data-testid="auto-print-banner-settings">
                <SettingsIcon size={11} /> Ayarlar
            </button>
        </div>
    );
}
